import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import RepresentantSearch from 'components/Shared/RepresentantSearch';

const styles = theme => ({
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },
    link: theme.style.link,
    button: {
        margin: '8px 8px 0px 0px'
    },
    representantSearch: {
        minHeight: 420
    }
});

class AdministrationRepresentants extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            representantCode: ''
        };
    }

    handleChangeRepresentant = (representantCode) => {
        this.setState(
            {
                ...this.state,
                representantCode: representantCode
            });
    };

    render() {
        let { representantCode } = this.state;
        let { classes } = this.props;

        return (
            <React.Fragment>
                <Typography gutterBottom variant="h5">
                    Administration des représentants
                </Typography>

                <Card className={classNames(classes.paper, classes.representantSearch)}>
                    <Typography gutterBottom variant="h6">
                        Choix d'un représentant à éditer
                    </Typography>

                    <RepresentantSearch
                        namespace={"administration"}
                        onChange={this.handleChangeRepresentant}
                        isRequired={false}
                    />

                    {(representantCode === '') && 
                        <Button disabled>Éditer</Button>
                    }

                    {(representantCode !== '') &&
                        <Link to={`/administration/representants/${representantCode}`} className={classes.link}>
                            <Button>Éditer</Button>
                        </Link>
                    }
                </Card>
            </React.Fragment>
        );
    }
}

AdministrationRepresentants.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AdministrationRepresentants);